import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
function SvgComponent(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 4,
    height: 3,
    viewBox: "0 0 4 3",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement(Path, {
    d: "M1.403 1.423c.016.131.03.278.04.426L2.794.5H1.241c.06.285.125.63.162.923z",
    stroke: "#A92D05"
  }));
}
export default SvgComponent;